/**
 * @flow
 * @relayHash 248329ef85c2487fe4e5509f2426ed85
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateBrandInput = {
  clientMutationId?: ?string,
  estimate_id: string,
  brand_id: string,
};
export type Logo_updateEstimateBrandMutationVariables = {|
  input: UpdateEstimateBrandInput
|};
export type Logo_updateEstimateBrandMutationResponse = {|
  +updateEstimateBrand: ?{|
    +estimate: ?{|
      +id: string,
      +brand_logo_url: ?string,
    |}
  |}
|};
export type Logo_updateEstimateBrandMutation = {|
  variables: Logo_updateEstimateBrandMutationVariables,
  response: Logo_updateEstimateBrandMutationResponse,
|};
*/


/*
mutation Logo_updateEstimateBrandMutation(
  $input: UpdateEstimateBrandInput!
) {
  updateEstimateBrand(input: $input) {
    estimate {
      id
      brand_logo_url
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateBrandInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateEstimateBrand",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateEstimateBrandInput!"
      }
    ],
    "concreteType": "UpdateEstimateBrandPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "estimate",
        "storageKey": null,
        "args": null,
        "concreteType": "Estimate",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "brand_logo_url",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Logo_updateEstimateBrandMutation",
  "id": null,
  "text": "mutation Logo_updateEstimateBrandMutation(\n  $input: UpdateEstimateBrandInput!\n) {\n  updateEstimateBrand(input: $input) {\n    estimate {\n      id\n      brand_logo_url\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Logo_updateEstimateBrandMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "Logo_updateEstimateBrandMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd93bc12f794049d41c435dfb81ac44a6';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Estimate/__generated__/Logo_updateEstimateBrandMutation.graphql.js